module.exports = __webpack_public_path__ + "img/html.caf462c9.svg";